import { memo } from 'react';
import {
  SingleToolSimilar,
  MARKETING_SLOGAN_TOOL,
  AD_COPY_GENERATOR_TOOL,
  SOCIAL_MEDIA_BIO_TOOL,
  FONT_GENERATOR_TOOL,
  ToolCategory,
} from '@quicktools/shared-components';

import MoreInfo from '../../sections/static/All/MoreInfo';
import analytics from '../../services/analytics';

import ImageWithTextWidget from './ImageWithTextWidget';
import HowToSection from './HowToSection';
import useStyle from './styles';

const SIMILAR_TOOLS = [SOCIAL_MEDIA_BIO_TOOL, AD_COPY_GENERATOR_TOOL, MARKETING_SLOGAN_TOOL];

function Landing({ text }) {
  const classes = useStyle();
  const getStarted = () => {
    console.log('getStarted function needs to be done ');
  };

  return (
    <div className={classes.landing}>
      {text?.imageSection.map((item, index) => (
        <ImageWithTextWidget props={item} key={index} />
      ))}
      <HowToSection getStarted={getStarted} howToSection={text.howToSection} />
      <MoreInfo props={text?.moreInfo} />
      <SingleToolSimilar
        current={FONT_GENERATOR_TOOL}
        analytics={analytics}
        similar={SIMILAR_TOOLS}
        paragraph={text.similarTools.paragraph}
        category={ToolCategory.Text}
      />
    </div>
  );
}

export default memo(Landing);
